import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import type {
  TrackedWalletTableColumnId,
  TrackedWalletTableContext,
} from '../atoms/reatom-tracked-wallet-column-id'
import type { Maker } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'
import type { DataTableModel } from '@root/shared/ui-kit'

type Props = {
  context: TrackedWalletTableContext
  tableModel: DataTableModel<
    Maker.Maker,
    TrackedWalletTableColumnId,
    object,
    TrackedWalletTableContext
  >
} & ClassNameProps

export const TrackedWalletTable: React.FC<Props> = ({
  className,
  tableModel,
  context,
}) => {
  return (
    <AppDataTable
      className={className}
      model={tableModel}
      rowHeight={60}
      context={context}
    />
  )
}
